import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntelliDatepickerComponent } from './intelli-datepicker/intelli-datepicker.component';

import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
//import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormField as MatFormField } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { IntelliYesornoComponent } from './intelli-yesorno/intelli-yesorno.component';
import { IntelliDataSelectorComponent } from './intelli-data-selector/intelli-data-selector.component';
import { IntelliSelectorComponent } from './intelli-selector/intelli-selector.component';
import { IntelliDecimalComponent } from './intelli-decimal/intelli-decimal.component';
import { IntelliEditMenuComponent } from './intelli-edit-menu/intelli-edit-menu.component';
import { IntelliTextEditorComponent } from './intelli-text-editor/intelli-text-editor.component';

import { IntelliDataSelectorService } from './intelli-data-selector/intelli-data-selector.service';
import { IntelliTextAreaEditorComponent } from './intelli-textarea-editor/intelli-textarea-editor.component';
import { PartialsModule } from '../../../views/partials/partials.module';
import { DeleteConfirmDialogComponent } from '../common-dialogs/delete-confirm-dialog/delete-confirm-dialog.component';
import { CommonDialogsModule } from '../common-dialogs/common-dialogs.module';
import { IntelliCreditCarcEditorComponent } from './intelli-credit-card-editor/intelli-credit-card-editor.component';
import { IntelliCustomerDataEditorComponent } from './intelli-customer-data-editor/intelli-customer-data-editor.component';
import { MatDialogModule } from '@angular/material/dialog';
//import { CardModule } from 'ngx-card';


@NgModule({
    imports: [
        CommonModule,
        MatInputModule,
        FormsModule,
        HttpClientModule,
        MatNativeDateModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatToolbarModule,
        MatIconModule,
        MatMenuModule,
        MatCardModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        PartialsModule,
        CommonDialogsModule,
   //     CardModule
    ],
    exports: [IntelliDatepickerComponent,
        IntelliCreditCarcEditorComponent,
        IntelliYesornoComponent,
        IntelliDataSelectorComponent,
        IntelliSelectorComponent,
        IntelliDecimalComponent,
        IntelliEditMenuComponent,
        IntelliTextEditorComponent,
        IntelliTextAreaEditorComponent,
        IntelliCustomerDataEditorComponent
    ],
    declarations: [
        IntelliDatepickerComponent,
        IntelliYesornoComponent,
        IntelliDataSelectorComponent,
        IntelliSelectorComponent,
        IntelliDecimalComponent,
        IntelliEditMenuComponent,
        IntelliTextEditorComponent,
        IntelliTextAreaEditorComponent,
        IntelliCreditCarcEditorComponent,
        IntelliCustomerDataEditorComponent
    ],
    providers: [IntelliDataSelectorService]
    ,
   schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class IntelliControlsModule { }
